import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../components';

interface LogoutButtonWithCountdownProps
  extends Omit<React.ComponentProps<'button'>, 'children' | 'onClick'> {
  countdownTime: number;
  onLogout: () => void;
}

function LogoutButtonWithCountdown(props: Readonly<LogoutButtonWithCountdownProps>) {
  const { countdownTime, onLogout, ...restProps } = props;
  const { t } = useTranslation();

  const [countdown, setCountdown] = useState(countdownTime);

  const handleLogout = () => {
    onLogout();
  };

  const handleClick = () => {
    handleLogout();
  };

  useEffect(() => {
    const countdownInterval = () => {
      setCountdown((prev) => {
        const countdown = prev - 1;
        if (countdown === 0) {
          handleLogout();
          clearInterval(interval);
        }
        return countdown;
      });
    };
    const interval = setInterval(countdownInterval, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Button onClick={handleClick} {...restProps}>
      {t('logout')} ({countdown}s)
    </Button>
  );
}

export default LogoutButtonWithCountdown;
